import { PublicLayout } from '../../../shared/layout/publicLayout';
import { Panel } from '../../../shared/ui/panel/panels';
import { PrimaryButton } from '../../../shared/ui/Inputs';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signPrivacyTerm } from '../../../services/configuration/userManagementService';
import { LoginService } from '../../../services/auth';

export const PrivacyPage = () => {
    const [accepted, setAccepted] = useState(false);
    let navigate = useNavigate();
    const signPrivacyTermCallback = async () => {
        const result = await signPrivacyTerm();
        if (result.signed === true) {
            LoginService.setPrivacyTermAccepted();
            navigate('/orders');
        }
    };
    return (
        <PublicLayout
            outlet={
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        width: '100%',
                        minHeight: '100vh',
                        padding: '20px',
                        boxSizing: 'border-box',
                    }}
                >
                    <Panel
                        style={{
                            padding: '30px',
                            maxWidth: '800px',
                            width: '100%',
                            textAlign: 'left',
                            backgroundColor: '#ffffff',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                            borderRadius: '8px',
                            marginTop: '20px',
                        }}
                    >
                        <div>
                            <h2 style={{ marginTop: 0, color: '#00A651' }}>Termo de Privacidade</h2>
                            <p>
                                Este termo de privacidade descreve como as informações pessoais são coletadas, usadas e compartilhadas
                                quando você utiliza nossos serviços.
                            </p>

                            <h3>Coleta de Informações Pessoais:</h3>
                            <p>
                                Coletamos informações pessoais, como nome, endereço de e-mail e informações de pagamento quando você se
                                registra em nossos serviços ou faz uma compra. Também podemos coletar informações sobre seu uso dos
                                nossos serviços, como seu histórico de navegação e as páginas que você visitou.
                            </p>

                            <h3>Uso de Informações Pessoais:</h3>
                            <p>
                                Usamos as informações coletadas para fornecer e melhorar nossos serviços, personalizar sua experiência e
                                enviar informações importantes, como atualizações e promoções. Podemos compartilhar informações com
                                terceiros, como provedores de serviços e parceiros de publicidade, para fornecer serviços e anúncios
                                relevantes.
                            </p>

                            <h3>Proteção de Informações Pessoais:</h3>
                            <p>
                                Tomamos medidas de segurança adequadas para proteger suas informações pessoais contra perda, uso
                                indevido e acesso não autorizado. Somente fornecemos acesso às informações pessoais a funcionários que
                                precisam delas para realizar suas funções.
                            </p>

                            <h3>Seus Direitos de Privacidade:</h3>
                            <p>
                                Você tem o direito de acessar, corrigir e excluir suas informações pessoais. Também podemos permitir que
                                você opte por sair de determinados tipos de comunicações de marketing. Entre em contato conosco para
                                obter mais informações.
                            </p>

                            <h3>Atualizações deste Termo de Privacidade:</h3>
                            <p>
                                Podemos atualizar este termo de privacidade periodicamente para refletir mudanças em nossas práticas de
                                privacidade. Recomendamos que você revise este termo regularmente para se manter informado sobre nossas
                                práticas de privacidade mais recentes.
                            </p>
                        </div>
                        <div
                            style={{
                                padding: '16px',
                                backgroundColor: '#f7f7f7',
                                borderRadius: '4px',
                                marginTop: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                            }}
                        >
                            <input
                                checked={accepted}
                                onChange={(e) => setAccepted(!accepted)}
                                type="checkbox"
                                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                            />
                            <label style={{ margin: 0, cursor: 'pointer', fontSize: '14px' }}>
                                Aceito os termos e condições de uso do Portal Homecare
                            </label>
                        </div>
                        <div style={{ textAlign: 'center', marginTop: '24px', paddingBottom: '10px' }}>
                            <PrimaryButton disabled={!accepted} onClick={signPrivacyTermCallback} style={{ width: '140px' }}>
                                Assinar
                            </PrimaryButton>
                        </div>
                    </Panel>
                </div>
            }
        ></PublicLayout>
    );
};
